/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppProtectionAssuranceSummaryQueryVariables = Types.Exact<{
  owned?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type IAppProtectionAssuranceSummaryQuery = {
  __typename?: 'Query';
  appProtectionAssuranceSummary: {
    __typename?: 'AppProtectionAssuranceSummary';
    certificationCertifiedCount: number;
    certificationCertifiedPercentage: number;
    certificationValidatedCount: number;
    certificationValidatedPercentage: number;
    certificationVerifiedCount: number;
    certificationVerifiedPercentage: number;
    totalProtectionsCount: number;
    backupsCount: number;
    custodianProfilesCount: number;
    escrowsCount: number;
  };
};

export const AppProtectionAssuranceSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'appProtectionAssuranceSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'owned' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appProtectionAssuranceSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'owned' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'owned' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'certificationCertifiedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificationCertifiedPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificationValidatedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificationValidatedPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificationVerifiedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificationVerifiedPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalProtectionsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backupsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'custodianProfilesCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'escrowsCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppProtectionAssuranceSummaryQuery, IAppProtectionAssuranceSummaryQueryVariables>;
